/* eslint-disable no-unused-vars */
export enum TabEnum {
  Booking = "Booking",
  Info = "Info",
  Units = "Units",
}

export enum CollapsibleTextEnum {
  TrimCharacterCount = 500,
  Zero = 0,
}

export enum DateFormats {
  Add5Days = 5,
  DayNumber = "DD",
  Day = "day",
  Days = "days",
  DayMonth = "ddd, D MMM",
  DayDateMonth = "dddd D MMMM",
  DayDateMonthDe = "dddd, D. MMMM",
  DayDateMonthEn = "dddd, MMMM D",
  Minus5Days = -5,
  Minutes = "minutes",
  Hour = "hour",
  Hours = "hours",
  MonthDay = "MM",
  PHDate = "2000-01-01",
  Time = "HH:mm",
  WeekDay = "dddd",
  Y = "YYYY",
  YMD = "YYYY-MM-DD",
  OneYear = 365,
  YMDTime = "YYYY-MM-DDTHH:mm",
  YMDTimeWithSeconds = "YYYY-MM-DDTHH:mm:ss",
  LT = "LT",
  TimeWithSeconds = "HH:mm:ss",
  Time12h = "hh:mm A",
  Time12WithoutAMPM = "hh:mm",
  DateTime = "ddd, D MMM HH:mm",
  DayDateYear = "dd DD.MM.YYYY",
}

export enum ImageTypes {
  background = "background",
  slider = "slider",
}

export enum ImagePositionTypes {
  background = 0,
  slider = 1,
}

export enum DataTypes {
  number = "number",
}

export enum calculationTypes {
  basicSlotLength = 15,
  fallbackValue = 0,
  hourSplitBy15 = 4,
  percent = 100,
}

export enum imageCarousel {
  defaultInterval = 3000,
  defaultSpeed = 500,
}

export type DragDevices = "desktop" | "tablet" | "mobile";
